"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.vehicleMakeDeserialize = void 0;
const deserializeArray_1 = __importDefault(require("./deserializeArray"));
const deserializeNumber_1 = require("./deserializeNumber");
const deserializeObject_1 = __importDefault(require("./deserializeObject"));
const deserializeString_1 = require("./deserializeString");
function vehicleMakeDeserialize(value, id) {
    const object = (0, deserializeObject_1.default)(value);
    return {
        id: (0, deserializeString_1.deserializeString)(id),
        name: (0, deserializeString_1.deserializeString)(object.name),
        years: deserializeYears(object.years),
    };
}
exports.vehicleMakeDeserialize = vehicleMakeDeserialize;
const deserializeYears = (0, deserializeArray_1.default)(value => (0, deserializeNumber_1.deserializeNumber)(value, 0, 3000, true));
